
    const {loadRemote} = require("@module-federation/runtime")
    const {initPromise} = require("__mf__virtual/wirecare_provider__mf_v__runtimeInit__mf_v__.js")
    const res = initPromise.then(_ => loadRemote("shipping/CartButton"))
    const exportModule = await initPromise.then(_ => res)
    module.exports = exportModule
  